// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","logo":"App_logo__1ItuU","imprintLink":"App_imprintLink__2xE4a","link":"App_link__TB6Cl"};